export interface PlatformStats { active_subscribers: number; past_due_subscribers: number; suspended_subscribers: number; cancelled_subscribers: number }
export async function fetchPlatformStatistics(token: string): Promise<PlatformStats> {
  const response=await fetch('https://vorbello.eu/wp-json/vorbello/v1/platform/statistics', {headers:{Authorization:`Bearer ${token}`}, credentials:'omit',cache:'no-store'});
  const data=await response.json();
  if (!response.ok || data?.success !== true || !data.statistics) throw new Error('Statisticile nu sunt disponibile.');
  const stats={} as PlatformStats;
  for (const key of ['active_subscribers','past_due_subscribers','suspended_subscribers','cancelled_subscribers'] as const) {
    const value=data.statistics[key];
    if (!Number.isSafeInteger(value) || value<0) throw new Error('Statistici invalide.');
    stats[key]=value;
  }
  return stats;
}
